export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./promotions.vue?vue&type=template&id=40ca1f0c"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/promotions/promotions.vue?vue&type=template&id=40ca1f0c
// module id = crLS
// module chunks = 0